<style lang="less" scoped>
  .search-form {
    width: 400px;
  }
</style>

<template lang="pug">
  #order.admin-container
    .admin-title-cover
      .admin-title 약재 관리
      .admin-options
        router-link(to="/admin/drug/add")
          el-button(type="default" native-type="button") 약재 추가
    .admin-content-cover
      .order-list-cover
        el-table(
        :data="drugs"
        style="width: 100%")
          el-table-column(
            prop="name"
            label="약재명")
            template(slot-scope="scope")
              router-link(:to="`/admin/drug/${scope.row._id}`") {{scope.row.name}}
          el-table-column(
            label="설명")
            template(slot-scope="scope")
              span {{scope.row.description || ''}}
          el-table-column(
            prop="price"
            label="g당 가격")
          el-table-column(label="재고 여부")
            template(slot-scope="scope")
              span {{!scope.row.unavailable ? '있음' : '없음'}}
      .tc(style="padding-top: 16px;")
        pagination(v-if='pageOption', v-bind='pageOption')
</template>

<script>
import pagination from '@/components/pagination';

const limit = 25;

export default {
  props: ['index'],
  data() {
    return {
      drugs: null,
      pageOption: null,
      search: {
        q: null,
      },
    };
  },
  methods: {
    getQueryString() {
      const query = {};
      Object.assign(query, this.$route.query);
      return query;
    },
    async refreshPagination() {
      const queryString = this.getQueryString();
      const totalCount = await this.$http.get('/ingredients/count', { params: queryString });
      const currentPage = this.$route.query.page || 0;
      return this.$pagination(currentPage * 1, limit, 5, totalCount.data);
    },
    async refreshDrugs() {
      const params = this.getQueryString();
      params.skip = params.page ? params.page * limit : 0;
      params.limit = limit;
      const { data } = await this.$http.get('/ingredients', { params: params });
      return data;
    },
  },
  watch: {
    async $route() {
      this.pageOption = await this.refreshPagination();
      this.drugs = await this.refreshDrugs();
    },
  },
  async mounted() {
    this.pageOption = await this.refreshPagination();
    this.drugs = await this.refreshDrugs();
  },
  components: {
    pagination,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/drug.vue